import './app.css';



/* is production */
// const isProd = process.env.NODE_ENV === 'production';



/* data */
const data = require('./js/data.json');



/* analytics */
const analytics = require('universal-ga');

analytics.initialize(data.meta.trackingID);
analytics.pageview('/index');

if (data.meta.clientTrackingID.length > 0) {
    analytics.create(data.meta.clientTrackingID, 'clientTracker');
    analytics.name('clientTracker').pageview('/index');
}

const analyticsEvent = (category, action, options) => {
    analytics.event(category, action, options);

    if (data.meta.clientTrackingID.length > 0) {
        analytics.name('clientTracker').event(category, action, options);
    }
};

// analyticsEvent('Page', 'load', {eventLabel: 'Successfully'});



/* svg icons */
const svg4everybody = require('svg4everybody');
svg4everybody();



/* jquery */
window.$ = window.jQuery = require('jquery');



/* vivus */
const Vivus = require('vivus');



/* svg.js */
const SVG = require('svg.js');



/* cross */
// const crossAnimation = () => {
//     const container = document.querySelector('#progress__cross');
//     container.innerHTML = container.innerHTML.length > 0 ? '' : container.innerHTML;

//     const containerWidth = container.offsetWidth;
//     const containerHeight = container.offsetHeight;

//     const draw = SVG('progress__cross').size('100%', '100%');

//     draw.line(0, 0, 0, 0).stroke({ color: '#fff', width: 1, linecap: 'round' }).animate(500, SVG.easing.bounce).during(function(t, morph) {
//         this.attr({
//             x2: morph(0, containerWidth),
//             y2: morph(0, containerHeight)
//         })
//     });

//     draw.line(0, containerHeight, 0, containerHeight).stroke({ color: '#fff', width: 1, linecap: 'round' }).delay(1000).animate(500, SVG.easing.bounce).during(function(t, morph) {
//         this.attr({
//             x2: morph(0, containerWidth),
//             y2: morph(containerHeight, 0)
//         })
//     });
// }



/* causes */
const causesAnimation = () => {
    const container = document.querySelector('#causes');
    container.innerHTML = '';

    const draw = SVG('causes').size(container.offsetWidth, container.offsetHeight);

    draw.clear();

    const elements = [...document.querySelectorAll('.causes__item .figure')];
    const targets = [...document.querySelectorAll('.causes__target')];
    const elementsPos = [];
    const targetsPos = [];

    elements.forEach(item => {
        elementsPos.push(item.getBoundingClientRect());
    });

    targets.forEach(item => {
        targetsPos.push(item.getBoundingClientRect());
    });

    for (let i = 0, len = elementsPos.length; i < len; i++) {
        draw.line(elementsPos[i].left + elementsPos[i].width / 2, elementsPos[i].top + elementsPos[i].height / 2, elementsPos[i].left + elementsPos[i].width / 2, elementsPos[i].top + elementsPos[i].height / 2).stroke({width: 2, color: '#2a2c35'}).animate(1000, SVG.easing.bounce).during(function(t, morph) {
            this.attr({
                x2: morph(elementsPos[i].left + elementsPos[i].width / 2, targetsPos[i].left + targetsPos[i].width / 2),
                y2: morph(elementsPos[i].top + elementsPos[i].height / 2, targetsPos[i].top + targetsPos[i].height / 2)
            })
        });
    }
};

jQuery(window).resize(function() {
    if (jQuery('body').hasClass('pp-viewing-s3')) {
        causesAnimation();
    }
});



/* simptoms */
const simptomsAnimation = () => {
    const iconPainted = (e) => {
        e.el.parentElement.parentElement.setAttribute('data-painted', 'true');
    };

    new Vivus('simptoms__increased', {
        duration: 100,
        pathTimingFunction: Vivus.EASE_IN
    }, iconPainted);
    new Vivus('simptoms__delayed', {
        duration: 150,
        pathTimingFunction: Vivus.EASE_IN
    }, iconPainted);
    new Vivus('simptoms__intermittent', {
        duration: 200,
        pathTimingFunction: Vivus.EASE_IN
    }, iconPainted);
    new Vivus('simptoms__incomplete', {
        duration: 250,
        pathTimingFunction: Vivus.EASE_IN
    }, iconPainted);
};



/* complications */
const complicationsAnimation = () => {
    const iconPainted = (e) => {
        e.el.parentElement.parentElement.setAttribute('data-painted', 'true');
    };

    new Vivus('complications__stones', {
        duration: 100,
        pathTimingFunction: Vivus.EASE_IN
    }, iconPainted);
    new Vivus('complications__pyelonephritis', {
        duration: 150,
        pathTimingFunction: Vivus.EASE_IN
    }, iconPainted);
    new Vivus('complications__prostatecancer', {
        duration: 200,
        pathTimingFunction: Vivus.EASE_IN
    }, iconPainted);
};



/* chart */
const Chartist = require('chartist');

const chartLabels = data.sections[3].russia.stat.diagram.map(item => item.year);
const chartSeries = data.sections[3].russia.stat.diagram.map(item => item.number);

const chartData = {
    labels: chartLabels,
    series: [
        chartSeries
    ]
};

const chartOptions = {
    low: 0,
    showArea: true,
    showLine: false,
    showPoint: false,
    fullWidth: true,
    showGridBackground: true,
    axisX: {
        offset: 40,
        showLabel: true,
        showGrid: true
    },
    axisY: {
        offset: 50,
        scaleMinSpace: 10,
        showLabel: true,
        showGrid: true
    }
};

const chart = new Chartist.Line('.ct-chart', chartData, chartOptions);

chart.on('draw', function(data) {
    if(data.type === 'area') {
        data.element.animate({
            d: {
                begin: 2000 * data.index,
                dur: 2000,
                from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
                to: data.path.clone().stringify(),
                easing: Chartist.Svg.Easing.easeOutQuint
            }
        });
    }
});

chart.on('created', function() {
    document.querySelector('.ct-chart-line').insertAdjacentHTML('afterbegin', '<defs><linearGradient id="chart_gradient"><stop style="stop-color:#2d89c9" offset="0%"></stop><stop style="stop-color:#e82262" offset="100%"></stop></linearGradient></defs>');
    document.querySelector('.ct-area').setAttribute('fill', 'url(#chart_gradient)');
});

const chartAnimation = () => {
    chart.update();
}



/* page pilipng */
require('pagepiling.js');

$(document).ready(function() {
    if ($(window).width() > 425 && $(window).height() > 425) {
        $('.sections').pagepiling({
            menu: '#menu',
            anchors: ['s1', 's2', 's3', 's4', 's5', 's6', 's7'],
            animateAnchor: true,
            direction: 'vertical',
            verticalCentered: false,
            navigation: false,
            keyboardScrolling: true,
            onLeave: function(index, nextIndex, direction) {

                analyticsEvent('Slide', 'turn', {eventLabel: 'NextIndex: ' + nextIndex});

                if (nextIndex === 2) {
                    // crossAnimation();
                } else if (nextIndex === 3) {
                    causesAnimation();
                } else if (nextIndex === 4) {
                    chartAnimation();
                } else if (nextIndex === 5) {
                    simptomsAnimation();
                } else if (nextIndex === 6) {
                    complicationsAnimation();
                }
                if (index === 4 && direction === 'up') {
                    setTimeout(causesAnimation, 1000);
                } else if (index === 6 && direction === 'up') {
                    setTimeout(simptomsAnimation, 500);
                } else if (index === 7 && direction === 'up') {
                    setTimeout(complicationsAnimation, 500);
                }
            }
        });
    }
});



/* in view */
const inView = require('in-view');

// inView('#progress__cross')
//     .on('enter', () => {
//         crossAnimation();
//     })
//     .on('exit', elem => {
//         elem.innerHTML = '';
//     });

// inView('#progress__arrow')
//     .on('enter', elem => {
//         elem.setAttribute('data-inview', 'true');
//     })
//     .on('exit', elem => {
//         elem.removeAttribute('data-inview');
//     });

inView('.ct-chart')
    .on('enter', () => {
        chartAnimation();
    });

inView('.simptoms')
    .on('enter', () => {
        simptomsAnimation();
    })
    .on('exit', elem => {
        const items = [...elem.querySelectorAll('.simptoms__item')];
        items.forEach(item => {
            item.removeAttribute('data-painted');
        });
    });

inView('.complications')
    .on('enter', () => {
        complicationsAnimation();
    })
    .on('exit', elem => {
        const items = [...elem.querySelectorAll('.complications__item')];
        items.forEach(item => {
            item.removeAttribute('data-painted')
        });
    });



/* header menu */
const menuButton = document.querySelector('.header__menu');
menuButton.addEventListener('click', () => {
    menuButton.classList.toggle('header__menu--open');
});



/* race block */
const raceTitle = document.querySelector('.race__title');
raceTitle.addEventListener('click', () => {
    raceTitle.parentElement.parentElement.classList.toggle('inner--showrace');
});



/* share */
const shareButtons = [...document.querySelectorAll('.header__sharing .share__item')];

shareButtons.forEach(button => {
    button.addEventListener('click', () => {
        analyticsEvent('Share', 'click', {eventLabel: 'Social: ' + button.dataset.type});
    });
});



/* external links */
const extLinks = [...document.querySelectorAll('a[href^="http://afalaza.ru"]')];

extLinks.forEach(link => {
    link.addEventListener('click', () => {
        analyticsEvent('Link', 'click', {eventLabel: 'Place: ' + link.dataset.type});
    });
});



/* turn from 1 slide */
document.querySelector('.section--1 .title').addEventListener('click', () => {
    $.fn.pagepiling.moveSectionDown();
});

document.querySelector('.section--1 .content .icon').addEventListener('click', () => {
    $.fn.pagepiling.moveSectionDown();
});



/* service worker */
// if ('serviceWorker' in navigator && isProd) {
//     navigator.serviceWorker.register('./sw.js');
// }



// WEBPACK FOOTER //
// ./app.js